module.exports = __webpack_public_path__ + "media/images/parceiros_pagamentos/neon_menor-a932ccedb98881431f5be03d1b47f381.png";